// Verticals
export const VERTICALS = [
  'Aca',
  'Antivirus',
  'Auto Insurance',
  'Bizop',
  'BloodSugar',
  'CC-Submit',
  'Debt',
  'E-Comm',
  'Final Expense',
  'GLP Weight Loss',
  'Guns',
  'Home Improvement',
  'Home Insurance',
  'Home Services',
  'Lottery',
  'Manifestation',
  'Medicare',
  'Memory Loss',
  'Mva',
  'Nerve Pain',
  'Nutra',
  'Personal Loan',
  'Pink Salt/Gelatine',
  'Refinance',
  'Roof',
  'Sweeps',
  'VSL',
  'Windows',
] as const;

export type Vertical = typeof VERTICALS[number];
